/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProblemType } from './ProblemType';
import {
    ProblemTypeFromJSON,
    ProblemTypeFromJSONTyped,
    ProblemTypeToJSON,
    ProblemTypeToJSONTyped,
} from './ProblemType';

/**
 * A problem of a competition with its position in the list.
 * @export
 * @interface CompetitionProblemRead
 */
export interface CompetitionProblemRead {
    /**
     * 
     * @type {string}
     * @memberof CompetitionProblemRead
     */
    problem_id: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionProblemRead
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionProblemRead
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionProblemRead
     */
    points_multiplier: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionProblemRead
     */
    points: number;
    /**
     * 
     * @type {ProblemType}
     * @memberof CompetitionProblemRead
     */
    problem_type: ProblemType;
    /**
     * 
     * @type {number}
     * @memberof CompetitionProblemRead
     */
    time_limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionProblemRead
     */
    is_public: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompetitionProblemRead
     */
    owner_id?: string | null;
}



/**
 * Check if a given object implements the CompetitionProblemRead interface.
 */
export function instanceOfCompetitionProblemRead(value: object): value is CompetitionProblemRead {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('ordinal' in value) || value['ordinal'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('points_multiplier' in value) || value['points_multiplier'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('problem_type' in value) || value['problem_type'] === undefined) return false;
    if (!('time_limit' in value) || value['time_limit'] === undefined) return false;
    if (!('is_public' in value) || value['is_public'] === undefined) return false;
    return true;
}

export function CompetitionProblemReadFromJSON(json: any): CompetitionProblemRead {
    return CompetitionProblemReadFromJSONTyped(json, false);
}

export function CompetitionProblemReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionProblemRead {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'ordinal': json['ordinal'],
        'name': json['name'],
        'points_multiplier': json['points_multiplier'],
        'points': json['points'],
        'problem_type': ProblemTypeFromJSON(json['problem_type']),
        'time_limit': json['time_limit'],
        'is_public': json['is_public'],
        'owner_id': json['owner_id'] == null ? undefined : json['owner_id'],
    };
}

export function CompetitionProblemReadToJSON(json: any): CompetitionProblemRead {
    return CompetitionProblemReadToJSONTyped(json, false);
}

export function CompetitionProblemReadToJSONTyped(value?: CompetitionProblemRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'ordinal': value['ordinal'],
        'name': value['name'],
        'points_multiplier': value['points_multiplier'],
        'points': value['points'],
        'problem_type': ProblemTypeToJSON(value['problem_type']),
        'time_limit': value['time_limit'],
        'is_public': value['is_public'],
        'owner_id': value['owner_id'],
    };
}

